import React, { Component } from "react";
import { Route, Router, Switch, Redirect } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { connect } from "react-redux";
import ConfirmationModal from "../common/confirmationModal";
import { SelectStage } from "../select-stage";
import { Login } from "../login";
import { Register } from "../register";
import { ForgetPassword } from "../forget-password";
import { ResetPassword } from "../reset-password";
import { GlossaryMenu } from "../glossary-menu";
import { GameMenu } from "../game-menu";
import { Presentation } from "../presentation";
import { CasesPage } from "../cases-page";
import { Leaderboard } from "../leaderboard";
import { Profile } from "../profile";
import { VerifyAccount } from "../verify-account";
import { history } from "../../index";
import { persistor } from "../../redux/store";

function PrivateRoute({ component: Component, authenticated, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        authenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }
    />
  );
}

function PublicRoute({ component: Component, authenticated, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        !authenticated ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
}

class Routers extends Component {
  render() {
    return (
      <Router history={history}>
        <PersistGate persistor={persistor}>
          <main>
            <ConfirmationModal />
            <Switch>
              <PrivateRoute
                path="/"
                component={SelectStage}
                exact
                authenticated={!!this.props.accessToken}
              />
              <PublicRoute
                path="/login"
                component={Login}
                exact
                authenticated={!!this.props.accessToken}
              />
              <PublicRoute path="/register" component={Register} exact />
              <PublicRoute
                path="/forgetpassword"
                component={ForgetPassword}
                exact
              />
              <PublicRoute
                path="/resetpassword"
                component={ResetPassword}
                exact
              />
              <PrivateRoute
                path="/resources"
                component={GlossaryMenu}
                exact
                authenticated={!!this.props.accessToken}
              />
              <PrivateRoute
                path="/game"
                component={GameMenu}
                exact
                authenticated={!!this.props.accessToken}
              />
              <PrivateRoute
                path="/presentation"
                component={Presentation}
                exact
                authenticated={!!this.props.accessToken}
              />
              <PrivateRoute
                path="/cases"
                component={CasesPage}
                exact
                authenticated={!!this.props.accessToken}
              />
              <PrivateRoute
                path="/leaderboard"
                component={Leaderboard}
                exact
                authenticated={!!this.props.accessToken}
              />
              <PrivateRoute
                path="/profile"
                component={Profile}
                exact
                authenticated={!!this.props.accessToken}
              />
              <PublicRoute path="/verify" component={VerifyAccount} exact />
            </Switch>
          </main>
        </PersistGate>
      </Router>
    );
  }
}

const mapStateToProps = (state) => ({
  accessToken: state.authDetails.accessToken,
});

export default connect(mapStateToProps)(Routers);
